export default __webpack_public_path__ + "static/8-start-04a1656ee3b744249d9b983b4b591413.png";